module.exports = __webpack_public_path__ + "media/pk_anim_stop.a46ce30a.mp3";